import { getFirestore } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue } from 'firebase/database';
import { API_URL } from '@/_libs/constants';

let config = {
  apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
  authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
  projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
  storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
  measurementId: process.env.NEXT_PUBLIC_FIREBASE_MEASUREMENT_ID,
};

if (API_URL.includes('soraban-pr-')) {
  config = { ...config };
  config.apiKey = process.env.NEXT_PUBLIC_FIREBASE_API_KEY_REVIEW_APP;
  config.authDomain = process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN_REVIEW_APP;
  config.databaseURL = process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL_REVIEW_APP;
  config.appId = process.env.NEXT_PUBLIC_FIREBASE_APP_ID_REVIEW_APP;
  config.projectId = process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID_REVIEW_APP;
}

const app = initializeApp(config);

export const database = getDatabase(app);
export const db = getFirestore(app);
export const uiVersionCountRef = ref(database, 'ui');
export const onValueFirebase = onValue;
